<template>
  <router-link :to="{ name: 'callouts-post', params: { id: callout.messageId } }">
    <div :class="$style.container">
      <CalloutAvatar :source="profile && profile.logo" :class="$style.avatar" />
      <div :class="$style.info">
        <div :class="$style.title">{{ title }}</div>
        <p :class="$style.text">{{ text }}</p>
      </div>
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex'
import CalloutAvatar from './CalloutAvatar'

export default {
  name: 'callouts-list-item',
  components: {
    CalloutAvatar
  },
  props: {
    callout: Object
  },
  computed: {
    ...mapGetters({
      getCalloutProfile: 'entities/calloutProfiles/find'
    }),
    profile () {
      return this.getCalloutProfile(this.callout.payload.profile)
    },
    title () {
      return this.callout.payload.advertising.title
    },
    text () {
      return this.callout.payload.advertising.text
    }
  }
}
</script>

<style module lang="scss">
.container {
  padding: 15px;
  border-bottom: 1px solid $border-color;
  display: flex;
  overflow: hidden;
  color: $text-darkest;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.9;
  }
}
.info {
  flex-grow: 1;
  overflow: hidden;
}
.avatar {
  margin-right: 12px;
  flex-shrink: 0;
}
.title {
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 10px;
}
.text {
  margin-top: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
